
<div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column"
    fxLayoutGap="32px"
    [@routeAnimation]="true">

    <!-- Internal User Home -->
    <mat-card *ngIf="isInternal">
        <div class="userHeading">
            My Requests
        </div>
        <div>
            <mat-card class="error"
                *ngIf="this.home.get(['UserInt','hasError']).value">
                {{this.home.get(['UserInt','errorMessage']).value}}
            </mat-card>
        </div>

        <div class="userTable">
            <ccms-table-ext-component
                [isLoading]="this.pending.get('UserInt').value"
                *ngIf="!this.home.get(['UserInt','hasError']).value"
                [data]="formCCDetails" [tableName]="'Internal'"
                [displayedColumns]='columnsForIntFormCC'></ccms-table-ext-component>
        </div>
    </mat-card>

    <!-- External User Home -->
    <mat-card *ngIf="!isInternal">
        <div class="userHeading">
            My Requests
        </div>
        <div>
            <mat-card class="error"
                *ngIf="this.home.get(['UserExt','hasError']).value">
                {{this.home.get(['UserExt','errorMessage']).value}}
            </mat-card>
        </div>

        <div class="userTable">
            <ccms-table-ext-component
                [isLoading]="this.pending.get('UserExt').value"
                *ngIf="!this.home.get(['UserExt','hasError']).value"
                [data]='formExtDetails' [tableName]="'External'"
                [displayedColumns]='columnsForFormExtDetails'>
            </ccms-table-ext-component>
        </div>
    </mat-card>
    <mat-card *ngIf="isInternal">

        <div class="userHeading" style="margin-bottom: 1%;">
            Admin
        </div>

        <mat-tab-group mat-stretch-tabs class="userTable"
            #adminTabGroup>
            <!-- CC -->
            <mat-tab label="Charitable Contribution">
                <div>
                    <mat-card class="error"
                        *ngIf="this.home.get(['FormCCExceptDraft','hasError']).value">
                        {{this.home.get(['FormCCExceptDraft','errorMessage']).value}}
                    </mat-card>
                </div>
                <div class="userTable">
                    <ccms-table-ext-component
                        [isLoading]="this.pending.get('FormCCExceptDraft').value"
                        *ngIf="adminTabGroup.selectedIndex === 0 &&
                        !this.home.get(['FormCCExceptDraft','hasError']).value"
                        [tableName]="'AdminCC'"
                        [data]='formCCSubmittedDetails'
                        [displayedColumns]='columnsForFormCCDetails'>
                    </ccms-table-ext-component>
                </div>
            </mat-tab>
            <!-- MG -->
            <mat-tab label="Matching Gift">
                <div>
                    <mat-card class="error"
                        *ngIf="this.home.get(['FormMGExceptDraft','hasError']).value">
                        {{this.home.get(['FormMGExceptDraft','errorMessage']).value}}
                    </mat-card>
                </div>

                <div class="userTable">
                    <ccms-table-ext-component
                        [isLoading]="this.pending.get('FormMGExceptDraft').value"
                        *ngIf="adminTabGroup.selectedIndex === 1 &&
                        !this.home.get(['FormMGExceptDraft','hasError']).value"
                        [tableName]="'AdminMG'"
                        [data]='formMGSubmittedDetails'
                        [displayedColumns]='columnsForFormCCDetails'>
                    </ccms-table-ext-component>
                </div>
            </mat-tab>
            <!-- CG -->
            <mat-tab label="Community Grants">
                <div>
                    <mat-card class="error"
                        *ngIf="this.home.get(['FormCGExceptDraft','hasError']).value">
                        {{this.home.get(['FormCGExceptDraft','errorMessage']).value}}
                    </mat-card>
                </div>

                <div class="userTable">
                    <ccms-table-ext-component
                        [isLoading]="this.pending.get('FormCGExceptDraft').value"
                        *ngIf="adminTabGroup.selectedIndex === 2 &&
                        !this.home.get(['FormCGExceptDraft','hasError']).value"
                        [tableName]="'AdminCG'"
                        [data]='formCGSubmittedDetails'
                        [displayedColumns]='columnsForExtCGPPSelectionExceptDraft'>
                    </ccms-table-ext-component>
                </div>
            </mat-tab>
            <!-- PP -->
            <mat-tab label="Plant for the Planet">
                <div>
                    <mat-card class="error"
                        *ngIf="this.home.get(['FormPPExceptDraft','hasError']).value">
                        {{this.home.get(['FormPPExceptDraft','errorMessage']).value}}
                    </mat-card>
                </div>

                <div class="userTable">
                    <ccms-table-ext-component
                        [isLoading]="this.pending.get('FormPPExceptDraft').value"
                        *ngIf="adminTabGroup.selectedIndex === 3 &&
                        !this.home.get(['FormPPExceptDraft','hasError']).value"
                        [tableName]="'AdminPP'"
                        [data]='formPPSubmittedDetails'
                        [displayedColumns]='columnsForExtCGPPSelectionExceptDraft'>
                    </ccms-table-ext-component>
                </div>
            </mat-tab>
            <!-- ES -->
            <mat-tab label="Event Sponsorship">
                <div>
                    <mat-card class="error"
                        *ngIf="this.home.get(['FormESExceptDraft','hasError']).value">
                        {{this.home.get(['FormESExceptDraft','errorMessage']).value}}
                    </mat-card>
                </div>

                <div class="userTable">
                    <ccms-table-ext-component
                        [isLoading]="this.pending.get('FormESExceptDraft').value"
                        *ngIf="adminTabGroup.selectedIndex === 4 &&
                        !this.home.get(['FormESExceptDraft','hasError']).value"
                        [tableName]="'AdminES'"
                        [data]='formESSubmittedDetails'
                        [displayedColumns]='columnsForExtESSelectionExceptDraft'>
                    </ccms-table-ext-component>
                </div>
            </mat-tab>

        </mat-tab-group>
    </mat-card>
    <mat-card *ngIf="hasApproverRole()">

        <div class="userHeading" style="margin-bottom: 1%;">
            My Approvals
        </div>
        <mat-tab-group mat-stretch-tabs class="userTable" #roleTabGroup>
            <!-- <mat-tab label="My Requests">
            </mat-tab> -->
            <mat-tab label="Internal Approvals" *ngIf="hasRole(isApprover)">
                <ng-template matTabContent>
                    <mat-tab-group mat-stretch-tabs class="userTable" #tabGroup
                        style="margin-top: 5px">
                        <mat-tab label="Pending Approval">
                            <div>
                                <mat-card class="error"
                                    *ngIf="this.home.get(['FormCCPendingApproval','hasError']).value">
                                    {{this.home.get(['FormCCPendingApproval','errorMessage']).value}}
                                </mat-card>
                            </div>
                            <ccms-table-ext-component
                                [isLoading]="this.pending.get('FormCCPendingApproval').value"
                                *ngIf="tabGroup.selectedIndex === 0 &&
                                !this.home.get(['FormCCPendingApproval','hasError']).value"
                                [tableName]="'PendingCC'"
                                [data]='pendingApprovalFormCCDetails'
                                [displayedColumns]='columnsForFormCCApproval'>
                            </ccms-table-ext-component>
                        </mat-tab>
                        <mat-tab label="Approved">
                            <div>
                                <mat-card class="error"
                                    *ngIf="this.home.get(['FormCCApproved','errorMessage']).value">
                                    {{this.home.get(['FormCCApproved','errorMessage']).value}}
                                </mat-card>
                            </div>
                            <ccms-table-ext-component
                                [isLoading]="this.pending.get('FormCCApproved').value"
                                *ngIf="tabGroup.selectedIndex === 1 &&
                                !this.home.get(['FormCCApproved','errorMessage']).value"
                                [tableName]="'ApprovedCC'"
                                [data]='approvedFormCCDetails'
                                [displayedColumns]='columnsForFormCCApproval'>
                            </ccms-table-ext-component>
                        </mat-tab>
                    </mat-tab-group>
                </ng-template>
                <!-- CC Form Approve -->
            </mat-tab>
            <mat-tab label="External Approvals/Reviewals"
                *ngIf="isExternalApproverReviewer">
                <ng-template matTabContent>
                    <mat-tab-group mat-stretch-tabs class="userTable"
                        style="margin-top: 5px"
                        #externalTabGroup>
                        <mat-tab label="Community Grants"
                            *ngIf="hasRole('CITAPPROVER|FOUNDATIONAPPROVER|CITREVIEWER|FOUNDATIONCCCREVIEWER|FOUNDATIONBODREVIEWER|DEV')">
                            <ng-template matTabContent>
                                <mat-card>
                                    <!-- <div class="userHeading">
                                        Community Grants (External)
                                    </div> -->
                                    <mat-tab-group mat-stretch-tabs
                                        class="userTable" #tabGroup>
                                        <mat-tab label="Pending Approval"
                                            *ngIf="hasRole('CITAPPROVER|FOUNDATIONAPPROVER')">
                                            <div>
                                                <mat-card class="error"
                                                    *ngIf="this.home.get(['FormCGPendingApproval','hasError']).value">
                                                    {{this.home.get(['FormCGPendingApproval','errorMessage']).value}}
                                                </mat-card>
                                            </div>

                                            <div class="userTable">
                                                <ccms-table-ext-component
                                                    [isLoading]="this.pending.get('FormCGPendingApproval').value"
                                                    *ngIf="tabGroup.selectedIndex
                                                    === 0
                                                    &&
                                                    !this.home.get(['FormCGPendingApproval','hasError']).value"
                                                    [tableName]="'PendingCG'"
                                                    [data]='pendingApprovalFormCGDetails'
                                                    [displayedColumns]='columnsForExtCGPPApproval'>
                                                </ccms-table-ext-component>
                                            </div>
                                        </mat-tab>

                                        <mat-tab label="Approved"
                                            *ngIf="hasRole('CITAPPROVER|FOUNDATIONAPPROVER')">
                                            <div>
                                                <mat-card class="error"
                                                    *ngIf="this.home.get(['FormCGApproved','hasError']).value">
                                                    {{this.home.get(['FormCGApproved','errorMessage']).value}}
                                                </mat-card>
                                            </div>

                                            <div class="userTable">
                                                <ccms-table-ext-component
                                                    [isLoading]="this.pending.get('FormCGApproved').value"
                                                    *ngIf="tabGroup.selectedIndex
                                                    === 1
                                                    &&
                                                    !this.home.get(['FormCGApproved','hasError']).value"
                                                    [tableName]="'ApprovedCG'"
                                                    [data]='approvedFormCGDetails'
                                                    [displayedColumns]='columnsForExtCGPPApproval'>
                                                </ccms-table-ext-component>
                                            </div>
                                        </mat-tab>
                                        <mat-tab label="Review"
                                            *ngIf="hasRole('CITREVIEWER|FOUNDATIONCCCREVIEWER|FOUNDATIONBODREVIEWER|DEV')">
                                            <div class="userTable">
                                                <ccms-table-ext-component
                                                    [data]='pendingReviewalFormCGDetails'
                                                    *ngIf="!hasErrorPendingReviewalFormCGDetails"
                                                    [isLoading]="false"
                                                    [tableName]="'ReviewCG'"
                                                    [displayedColumns]='columnsForExtCGPPApproval'>
                                                </ccms-table-ext-component>
                                            </div>
                                        </mat-tab>
                                    </mat-tab-group>
                                </mat-card>
                            </ng-template>
                            <!-- CG Form Approve -->

                            <!-- CG Form Review -->
                            <!-- <mat-card
                                *ngIf="hasRole('CITREVIEWER|FOUNDATIONCCCREVIEWER|FOUNDATIONBODREVIEWER|DEV')">
                                <ccms-table-ext-component
                                    [data]='pendingReviewalFormCGDetails'
                                    *ngIf="!hasErrorPendingReviewalFormCGDetails"
                                    [isLoading]="false"
                                    [tableName]="'ReviewCG'"
                                    [displayedColumns]='columnsForExtCGPPApproval'>
                                </ccms-table-ext-component>
                            </mat-card> -->
                        </mat-tab>
                        <mat-tab label="Event Sponsorships"
                            *ngIf="hasRole('CITAPPROVER|FOUNDATIONAPPROVER|CITREVIEWER|FOUNDATIONCCCREVIEWER|FOUNDATIONBODREVIEWER|DEV')">
                            <ng-template matTabContent>
                                <mat-card>
                                    <!-- <div class="userHeading">
                                        Event Sponsorship (External)
                                    </div> -->
                                    <mat-tab-group mat-stretch-tabs
                                        class="userTable" #tabGroup>
                                        <mat-tab label="Pending Approval"
                                            *ngIf="hasRole('CITAPPROVER|FOUNDATIONAPPROVER')">
                                            <div>
                                                <mat-card class="error"
                                                    *ngIf="this.home.get(['FormESPendingApproval','hasError']).value">
                                                    {{this.home.get('FormESPendingApproval')['errorMessage'].value}}
                                                </mat-card>
                                            </div>

                                            <div class="userTable">
                                                <ccms-table-ext-component
                                                    [isLoading]="this.pending.get('FormESPendingApproval').value"
                                                    *ngIf="tabGroup.selectedIndex
                                                    === 0
                                                    &&
                                                    !this.home.get(['FormESPendingApproval','hasError']).value"
                                                    [tableName]="'PendingES'"
                                                    [data]='pendingApprovalFormESDetails'
                                                    [displayedColumns]='columnsForExtESApproval'>
                                                </ccms-table-ext-component>
                                            </div>
                                        </mat-tab>
                                        <mat-tab label="Approved"
                                            *ngIf="hasRole('CITAPPROVER|FOUNDATIONAPPROVER')">
                                            <div>
                                                <mat-card class="error"
                                                    *ngIf="this.home.get(['FormESApproved','hasError']).value">
                                                    {{this.home.get('FormESApproved')['errorMessage'].value}}
                                                </mat-card>
                                            </div>

                                            <div class="userTable">
                                                <ccms-table-ext-component
                                                    [isLoading]="this.pending.get('FormESApproved').value"
                                                    *ngIf="tabGroup.selectedIndex
                                                    === 1
                                                    &&
                                                    !this.home.get(['FormESApproved','hasError']).value"
                                                    [tableName]="'ApprovedES'"
                                                    [data]='approvedFormESDetails'
                                                    [displayedColumns]='columnsForExtESApproval'>
                                                </ccms-table-ext-component>
                                            </div>
                                        </mat-tab>
                                        <mat-tab label="Review"
                                            *ngIf="hasRole('CITREVIEWER|FOUNDATIONCCCREVIEWER|FOUNDATIONBODREVIEWER|DEV')">
                                            <div class="userTable">
                                                <ccms-table-ext-component
                                                    [data]='pendingReviewalFormESDetails'
                                                    *ngIf="!hasErrorPendingReviewalFormESDetails"
                                                    [tableName]="'ReviewES'"
                                                    [displayedColumns]='columnsForExtESApproval'
                                                    [isLoading]="false">
                                                </ccms-table-ext-component>
                                            </div>
                                        </mat-tab>
                                    </mat-tab-group>
                                </mat-card>
                            </ng-template>
                            <!-- ES Form Approve -->

                            <!-- ES Form Review -->
                            <!-- <mat-card
                                *ngIf="hasRole('CITREVIEWER|FOUNDATIONCCCREVIEWER|FOUNDATIONBODREVIEWER|DEV')">
                                <div class="userHeading">
                                    Event Sponsorship (External) Review
                                </div>
    
                                <ccms-table-ext-component
                                    [data]='pendingReviewalFormESDetails'
                                    *ngIf="!hasErrorPendingReviewalFormESDetails"
                                    [tableName]="'ReviewES'"
                                    [displayedColumns]='columnsForExtESApproval'
                                    [isLoading]="false">
                                </ccms-table-ext-component>
                            </mat-card> -->
                        </mat-tab>
                        <mat-tab label="LG&E and KU Plant for the Planet"
                            *ngIf="hasRole(isPFTPApprover)">
                            <ng-template matTabContent>
                                <mat-card *ngIf="hasRole(isPFTPApprover)">
                                    <!-- <div class="userHeading">
                                        LG&E and KU Plant for the Planet (External)
                                    </div> -->
                                    <mat-tab-group mat-stretch-tabs
                                        class="userTable" #tabGroup>
                                        <mat-tab label="Pending Approval">
                                            <div>
                                                <mat-card class="error"
                                                    *ngIf="this.home.get(['FormPPPendingApproval','hasError']).value">
                                                    {{this.home.get(['FormPPPendingApproval','errorMessage']).value}}
                                                </mat-card>
                                            </div>

                                            <div class="userTable">
                                                <ccms-table-ext-component
                                                    [isLoading]="this.pending.get('FormPPPendingApproval').value"
                                                    *ngIf="tabGroup.selectedIndex
                                                    === 0
                                                    &&
                                                    !this.home.get(['FormPPPendingApproval','hasError']).value"
                                                    [tableName]="'PendingPP'"
                                                    [data]='pendingApprovalFormPPDetails'
                                                    [displayedColumns]='columnsForExtCGPPApproval'>
                                                </ccms-table-ext-component>
                                            </div>
                                        </mat-tab>

                                        <mat-tab label="Approved">
                                            <div>
                                                <mat-card class="error"
                                                    *ngIf="this.home.get(['FormPPApproved','hasError']).value">
                                                    {{this.home.get(['FormPPApproved','errorMessage']).value}}
                                                </mat-card>
                                            </div>

                                            <div class="userTable">
                                                <ccms-table-ext-component
                                                    [isLoading]="this.pending.get('FormPPApproved').value"
                                                    *ngIf="tabGroup.selectedIndex
                                                    === 1
                                                    &&
                                                    !this.home.get(['FormPPApproved','hasError']).value"
                                                    [tableName]="'ApprovedCG'"
                                                    [data]='approvedFormPPDetails'
                                                    [displayedColumns]='columnsForExtCGPPApproval'>
                                                </ccms-table-ext-component>
                                            </div>
                                        </mat-tab>
                                    </mat-tab-group>
                                </mat-card>
                            </ng-template>
                            <!-- PP Form Approve -->
                        </mat-tab>
                    </mat-tab-group>
                </ng-template>


            </mat-tab>
        </mat-tab-group>
    </mat-card>




</div>